<template>
	<div class="fi-row">
		<span class="fi-rowIcon"><sym-icon :name="icon"></sym-icon></span>
		<div class="fi-row-message">
			<custom-notification :text="fi.text" :url="fi.customURL" :link-name="fi.customLinkName"></custom-notification>
			<template v-if="fi.customValue0 === 'OP_WARNING'">
				<span>{{ env.msg('forceInfo.addAction') }}:</span>
				<it-link :to="'planActivity.do?k=contact&opportunity='+fi.customValue1" class="fbutton">{{ env.msg('forceInfo.contact') }}</it-link>
				<it-link :to="'planActivity.do?k=event&opportunity='+fi.customValue1" class="fbutton">{{ env.msg('forceInfo.event') }}</it-link>
				<it-link :to="'planActivity.do?k=task&opportunity='+fi.customValue1" class="fbutton">{{ env.msg('forceInfo.task') }}</it-link>
			</template>
			<a v-else-if="isMe" href="#" class="fbutton" @click.prevent="deleteFi">{{ env.msg('butt.ok') }}</a>
			<template v-if="isMe">
				<div v-if="fi.value" class="fi-value">{{ fi.value }}</div>
			</template>
			<fi-date :value="fi.entered"></fi-date>
		</div>
	</div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {ForceInfo} from "@t/processes/ForceInfo.ts";
import {injectEnv} from "@fd/Environment.ts";
import CustomNotification from "@/processes/CustomNotification.vue";
import ItLink from "@/router/ItLink.vue";
import FiDate from "@/processes/FiDate.vue";
import {useForceInfoStore} from "@/store/ForceInfoStore";

const props = defineProps<{
	fi: ForceInfo,
	responsible: string
}>();
const env = injectEnv();
const fis = useForceInfoStore();

const isMe = computed<boolean>(() => {
	return env.user && props.fi.responsible === env.user.login;
});

const icon = computed<string>(() => props.fi.customValue0 === 'OP_WARNING' ? "opportunity": "eye-eyebrow");

function deleteFi() {
	fis.deleteForceInfo(props.fi.id);
}

</script>

<style>

</style>